export default __webpack_public_path__ + "assets/models/e4d83a0b44d491a637a7a36282a18a45.glb";